export const clock = {
  now: (): number => Date.now(),
  date: (): Date => new Date()
};
